module.exports = __webpack_public_path__ + "img/terminal.9e5e37d5.png";